import Input, { SeturInputProps } from '@components/Input';
import { NameValidation } from '@constants/constants';

const allowedPattern = /^[a-zA-ZğüşöçıİĞÜŞÖÇ\s]*$/;

const PersonName = (props: SeturInputProps) => {
  return (
    <>
      <div
        style={{
          display: 'none',
        }}
      >
        <input
          type='text'
          id='PreventChromeAutocomplete'
          name='PreventChromeAutocomplete'
          autoComplete='address-level4'
        />
      </div>
      <Input
        maxLength={NameValidation.MAX_NAME_INPUT_LENGTH}
        {...props}
        onKeyDown={(e) => {
          if (!allowedPattern.test(e.key)) {
            e.preventDefault();
          }
        }}
        onPaste={(e) => {
          const pasteContent = e.clipboardData.getData('text');

          if (!allowedPattern.test(pasteContent)) {
            e.preventDefault();
          }
        }}
        onInput={(e) => {
          const input = e.target as HTMLInputElement;
          if (!allowedPattern.test(input.value)) {
            input.value = input.value.replace(/[^a-zA-ZğüşöçıİĞÜŞÖÇ\s]/g, '');
          }
        }}
      />
    </>
  );
};

export default PersonName;
